exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sync-error[data-v-3adacb08] {\n  max-width: 69%;\n  font-size: 0.75rem;\n  background-color: var(--alert);\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  border-radius: var(--radius);\n  color: var(--inverted);\n  position: absolute;\n  top: 0.75rem;\n  right: 3rem;\n}\n.sync-error[data-v-3adacb08]::first-letter {\n  text-transform: uppercase;\n}\n.sync-info[data-v-3adacb08] {\n  background-color: var(--info);\n}", ""]);

// exports
